import { render, staticRenderFns } from "./loginrecordlist.vue?vue&type=template&id=65c56216&scoped=true&"
import script from "./loginrecordlist.vue?vue&type=script&lang=js&"
export * from "./loginrecordlist.vue?vue&type=script&lang=js&"
import style0 from "./loginrecordlist.vue?vue&type=style&index=0&id=65c56216&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c56216",
  null
  
)

export default component.exports